import { QtyStepper } from '@/features/tickets';
import { fmtAMD } from '@/lib/format';
import type { CartItem } from '@/types';
import ImgSlot from '@/ui/ImgSlot';

import styles from './CartRow.module.css';

interface CartRowProps {
  item: CartItem;
  onQtyChange: (next: number) => void;
  onRemove: () => void;
}

export default function CartRow({ item, onQtyChange, onRemove }: CartRowProps) {
  return (
    <div className={styles.root}>
      <ImgSlot className={styles.img} />
      <div>
        <div className={styles.name}>{item.name}</div>
        <div className={styles.vari}>{item.variant}</div>
      </div>
      <QtyStepper value={item.qty} onChange={onQtyChange} />
      <span className={styles.price}>{fmtAMD(item.price * item.qty)}</span>
      <button
        type="button"
        className={styles.remove}
        onClick={onRemove}
        aria-label="remove"
      >
        ×
      </button>
    </div>
  );
}
